/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据订单号获取支付信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,
  orderType:
    | "SHOW"
    | "RECHARGE"
    | "COMMODITY"
    | "VIDEO"
    | "ACTIVITYAPPLY"
    | "MOVIE",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderPayInfoRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/order/pay-info/${orderId}/${orderType}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
